import React, {useState} from "react";
import moment from "moment";

import {Redirect, useHistory, Link} from "react-router-dom";
import {
    Button,
    Col,
    Row,
    Form,
    Input,
    Switch,
    Radio,
    Tag,
    Table,
    Select,
    Popconfirm,
    Modal
} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {RadioContainer, TableContainer} from "../../company/companyDetailOptions/optionsStyles";
import {useTranslation} from "react-i18next";
import {FormikProvider, useFormik, getIn, Formik} from "formik";
import {poolMergeOptionsValidation} from "./poolMergeOptionsValidation";
import {ErrorFocus} from "../../_defaultComponents/ErrorFocus/ErrorFocus";
import {
    PageWrapper,
    HeaderRow,
    BackButton,
    PoolTitle,
    CreateFormTableWrapper,
    LevelFormRow,
    DataTableWrapper,
    FilterSection,
    EditModalLevelRow,
    EditModalTableWrapper,
    EditModalActions
} from "./styles/PoolMergeOptions.styles";

const {Column} = Table;
const PoolMergeOptions = ({poolId}) => {
    const history = useHistory();
    const stores = useStore();
    const {t} = useTranslation(["mergeOptions", "courierTypes"]);

    const [recall, setRecall] = React.useState(false);
    const [radioValue, setRadioValue] = React.useState("motorCourier");
    const [filterValue, setFilterValue] = React.useState("ALL");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [timeValue, setTimeValue] = useState(30);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [editForm] = Form.useForm();

    const onChange = e => {
        setRadioValue(e.target.value);
    };

    const onChangeFilter = e => {
        setFilterValue(e);
    };

    const onDelete = async id => {
        const params = {
            poolId: poolId,
            mergeOptionId: id
        };
        const result = await stores.poolStore.deletePoolMergeOptions(params);
        if (result) {
            setRecall(!recall);
        }
    };

    const onEdit = record => {
        setIsEditModalVisible(true);
        setSelectedRecord(record);
        editForm.setFieldsValue({
            level: record.level,
            name: record.name,
            poolRate: record.poolRate,
            orderOnQueue: record.orderOnQueue,
            capacityRate: record.capacityRate,
            clickToDoorTime: record.clickToDoorTime,
            prepTime: record.prepTime,
            prepTimeBufferPercent: record.prepTimeBufferPercent,
            handOverTime: record.handOverTime,
            maxOrder: record.maxOrder,
            mergeWithOtherTypes: record.mergeWithOtherTypes,
            mergeWithOtherCompanies: record.mergeWithOtherCompanies,
            maxPickup: record.maxPickup
        });
    };

    const onStatusChange = async params => {
        const statusChangeParams = {
            poolId: poolId,
            mergeOptionId: params.mergeOptionId,
            isActive: params.isActive,
            timeMinutes: params.timeMinutes
        };
        const result = await stores.poolStore.updateStatusPoolMergeOptions(statusChangeParams);
        if (result) {
            setRecall(!recall);
        }
    };

    const onUpdateAllSubCompanies = async () => {
        const result = await stores.poolStore.updateAllSubCompaniesMergeOptions({
            poolId,
            courierType: radioValue
        });
        if (result) {
            setRecall(!recall);
        }
    };

    const createFormik = useFormik({
        initialValues: {
            options: {
                merge: {
                    isActive: true,
                    poolRate: 20,
                    orderOnQueue: 10,
                    capacityRate: 10,
                    clickToDoorTime: 60,
                    prepTime: 15,
                    prepTimeBufferPercent: 100,
                    handOverTime: 5,
                    maxOrder: 5,
                    applyMergeOptions: false,
                    mergeWithOtherTypes: false,
                    mergeWithOtherCompanies: true,
                    maxPickup: 2,
                    level: 1,
                    name: "Seviye 1",
                    courierType: radioValue
                }
            },
            timeMinutes: 30
        },
        enableReinitialize: true,
        validateOnChange: true,
        validationSchema: poolMergeOptionsValidation,
        onSubmit: async values => {
            const params = {
                ...values.options.merge,
                poolRate: parseFloat(values.options.merge.poolRate),
                orderOnQueue: parseInt(values.options.merge.orderOnQueue),
                capacityRate: parseFloat(values.options.merge.capacityRate),
                clickToDoorTime: parseInt(values.options.merge.clickToDoorTime),
                prepTime: parseInt(values.options.merge.prepTime),
                prepTimeBufferPercent: parseInt(values.options.merge.prepTimeBufferPercent),
                handOverTime: parseInt(values.options.merge.handOverTime),
                maxOrder: parseInt(values.options.merge.maxOrder),
                maxPickup: parseInt(values.options.merge.maxPickup),
                level: parseInt(values.options.merge.level),
                poolId: poolId
            };
            const result = await stores.poolStore.createPoolMergeOptions(params);
            if (result) {
                setRecall(!recall);
            }
        }
    });

    const handleEditSubmit = async values => {
        try {
            const params = {
                poolRate: parseFloat(values.poolRate),
                orderOnQueue: parseInt(values.orderOnQueue),
                capacityRate: parseFloat(values.capacityRate),
                clickToDoorTime: parseInt(values.clickToDoorTime),
                prepTime: parseInt(values.prepTime),
                prepTimeBufferPercent: parseInt(values.prepTimeBufferPercent),
                handOverTime: parseInt(values.handOverTime),
                maxOrder: parseInt(values.maxOrder),
                maxPickup: parseInt(values.maxPickup),
                mergeWithOtherTypes: values.mergeWithOtherTypes,
                mergeWithOtherCompanies: values.mergeWithOtherCompanies,
                level: parseInt(values.level),
                name: values.name,
                poolId: poolId,
                mergeOptionId: selectedRecord?._id,
                courierType: radioValue
            };

            const result = await stores.poolStore.updatePoolMergeOptions(params);
            if (result) {
                setRecall(!recall);
                setIsEditModalVisible(false);
                setSelectedRecord(null);
                editForm.resetFields();
            }
        } catch (error) {
            console.error("Güncelleme sırasında hata oluştu:", error);
        }
    };

    const handleEditCancel = () => {
        setIsEditModalVisible(false);
        setSelectedRecord(null);
        editForm.resetFields();
    };

    const {values, errors, touched, handleSubmit, setFieldValue} = createFormik;

    const [mergeOptionsLoading, mergeOptions] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolStore.getPoolMergeOptions.bind(null, {
            poolId: poolId
        }),
        dependencies: [recall],
        initialCall: Boolean(poolId),
        condition: Boolean(poolId)
    });

    const [poolSubCompaniesLoading, poolSubCompanies] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolStore.getPoolSubCompanies.bind(null, {
            poolId: poolId,
            courierType: radioValue,
            filter: filterValue
        }),
        dependencies: [recall, poolId, radioValue, filterValue],
        initialCall: Boolean(poolId),
        condition: Boolean(poolId)
    });

    const getFilteredData = () => {
        if (!mergeOptions) return [];
        return radioValue === "motorCourier"
            ? mergeOptions.motorCourierOptions
            : mergeOptions.carCourierOptions;
    };

    const filterOptions = [
        {key: "ALL", label: "Tümü"},
        {key: "SOME_USING", label: "Bazı alt firmalar kullanan"},
        {key: "ALL_USING", label: "Tüm alt firma kullanan"},
        {key: "NONE_USING", label: "Hiçbir alt firma kullanmayan"}
    ];

    const poolName = mergeOptions.poolName;

    const showModal = record => {
        setSelectedRecord(record);
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setTimeValue(0);
        setSelectedRecord(null);
    };

    return (
        <PageWrapper>
            <HeaderRow>
                <BackButton onClick={() => history.goBack()}>
                    <span style={{fontSize: "18px"}}>{"<"}</span> Geri Dön
                </BackButton>
                <PoolTitle>{poolName}</PoolTitle>
                <RadioContainer>
                    <Radio.Group
                        onChange={onChange}
                        value={radioValue}
                        data-testid="vehicleTypeRadioButton"
                        style={{
                            backgroundColor: "#fff",
                            padding: "4px",
                            borderRadius: "6px",
                            border: "1px solid #d9d9d9"
                        }}
                    >
                        <Radio
                            value={"motorCourier"}
                            data-testid="vehicleTypeRadioButton_option"
                            data-testvalue="motorCourier"
                        >
                            {t("longForm.motorCourier", {ns: "courierTypes"})}
                        </Radio>
                        <Radio
                            value={"carCourier"}
                            data-testid="vehicleTypeRadioButton_option"
                            data-testvalue="carCourier"
                        >
                            {t("longForm.carCourier", {ns: "courierTypes"})}
                        </Radio>
                    </Radio.Group>
                </RadioContainer>
            </HeaderRow>
            <TableContainer>
                <Form
                    autoComplete="off"
                    data-testid="companyMergeSettingsForm"
                    onFinish={createFormik.handleSubmit}
                >
                    <CreateFormTableWrapper>
                        <Table dataSource={[createFormik.values]} rowKey="_id" pagination={false}>
                            <ErrorFocus formik={createFormik} />
                            <FormikProvider value={createFormik}>
                                <Column
                                    title="Havuz Oranı (HO)"
                                    dataIndex="poolRate"
                                    align="center"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(errors, `options.merge.poolRate`) &&
                                                getIn(touched, `options.merge.poolRate`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(errors, `options.merge.poolRate`) &&
                                                getIn(touched, `options.merge.poolRate`)
                                                    ? getIn(errors, `options.merge.poolRate`)
                                                    : null
                                            }
                                        >
                                            <Input
                                                name="poolRate"
                                                value={values.options.merge.poolRate}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.poolRate",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                />
                                <Column
                                    title="Kuyruktaki Sipariş Sayısı (KSS)"
                                    dataIndex="orderOnQueue"
                                    align="center"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(errors, `options.merge.orderOnQueue`) &&
                                                getIn(touched, `options.merge.orderOnQueue`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(errors, `options.merge.orderOnQueue`) &&
                                                getIn(touched, `options.merge.orderOnQueue`)
                                                    ? getIn(errors, `options.merge.orderOnQueue`)
                                                    : null
                                            }
                                        >
                                            <Input
                                                type="number"
                                                name="orderOnQueue"
                                                value={values.options.merge.orderOnQueue}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.orderOnQueue",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                />
                                <Column
                                    title="Kapasite Oranı (KO)"
                                    dataIndex="capacityRate"
                                    align="center"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(errors, `options.merge.capacityRate`) &&
                                                getIn(touched, `options.merge.capacityRate`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(errors, `options.merge.capacityRate`) &&
                                                getIn(touched, `options.merge.capacityRate`)
                                                    ? getIn(errors, `options.merge.capacityRate`)
                                                    : null
                                            }
                                        >
                                            <Input
                                                type="number"
                                                name="capacityRate"
                                                value={values.options.merge.capacityRate}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.capacityRate",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                />

                                <Column
                                    title={`${t("fields.mergeOptions.clickToDoorTime.label", {
                                        ns: "common"
                                    })}(${t("units.minute.short", {
                                        ns: "common"
                                    })}) (${t("fields.mergeOptions.clickToDoorTime.short", {
                                        ns: "common"
                                    })})`}
                                    dataIndex="clickToDoorTime"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(errors, `options.merge.clickToDoorTime`) &&
                                                getIn(touched, `options.merge.clickToDoorTime`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(errors, `options.merge.clickToDoorTime`) &&
                                                getIn(touched, `options.merge.clickToDoorTime`)
                                                    ? getIn(errors, `options.merge.clickToDoorTime`)
                                                    : null
                                            }
                                        >
                                            <Input
                                                type="number"
                                                name="clickToDoorTime"
                                                data-testid="clickToDoorTime"
                                                value={values.options.merge.clickToDoorTime}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.clickToDoorTime",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                    align="center"
                                />
                                <Column
                                    title={`${t("fields.mergeOptions.prepTime.label", {
                                        ns: "common"
                                    })}(${t("units.minute.short", {
                                        ns: "common"
                                    })}) (${t("fields.mergeOptions.prepTime.short", {
                                        ns: "common"
                                    })})`}
                                    dataIndex="prepTime"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(errors, `options.merge.prepTime`) &&
                                                getIn(touched, `options.merge.prepTime`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(errors, `options.merge.prepTime`) &&
                                                getIn(touched, `options.merge.prepTime`)
                                                    ? getIn(errors, `options.merge.prepTime`)
                                                    : null
                                            }
                                        >
                                            <Input
                                                type="number"
                                                name="prepTime"
                                                data-testid="prepTime"
                                                value={values.options.merge.prepTime}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.prepTime",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                    align="center"
                                />
                                <Column
                                    title={`${t("fields.mergeOptions.prepTimeBufferPercent.label", {
                                        ns: "common"
                                    })}(%) (${t("fields.mergeOptions.prepTimeBufferPercent.short", {
                                        ns: "common"
                                    })})`}
                                    dataIndex="prepTimeBufferPercent"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(
                                                    errors,
                                                    `options.merge.prepTimeBufferPercent`
                                                ) &&
                                                getIn(
                                                    touched,
                                                    `options.merge.prepTimeBufferPercent`
                                                )
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(
                                                    errors,
                                                    `options.merge.prepTimeBufferPercent`
                                                ) &&
                                                getIn(
                                                    touched,
                                                    `options.merge.prepTimeBufferPercent`
                                                )
                                                    ? getIn(
                                                          errors,
                                                          `options.merge.prepTimeBufferPercent`
                                                      )
                                                    : null
                                            }
                                        >
                                            <Input
                                                type="number"
                                                name="prepTimeBufferPercent"
                                                data-testid="prepTimeBufferPercent"
                                                value={values.options.merge.prepTimeBufferPercent}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.prepTimeBufferPercent",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                    align="center"
                                />
                                <Column
                                    title={`${t("fields.mergeOptions.handOverTime.label", {
                                        ns: "common"
                                    })}(${t("units.minute.short", {
                                        ns: "common"
                                    })}) (${t("fields.mergeOptions.handOverTime.short", {
                                        ns: "common"
                                    })})`}
                                    dataIndex="handOverTime"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(errors, `options.merge.handOverTime`) &&
                                                getIn(touched, `options.merge.handOverTime`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(errors, `options.merge.handOverTime`) &&
                                                getIn(touched, `options.merge.handOverTime`)
                                                    ? getIn(errors, `options.merge.handOverTime`)
                                                    : null
                                            }
                                        >
                                            <Input
                                                type="number"
                                                name="handOverTime"
                                                data-testid="handOverTime"
                                                value={values.options.merge.handOverTime}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.handOverTime",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                    align="center"
                                />
                                <Column
                                    title={`${t("fields.mergeOptions.mergeMaxOrder.label", {
                                        ns: "common"
                                    })}(${t("units.piece.long", {
                                        ns: "common"
                                    })}) (${t("fields.mergeOptions.mergeMaxOrder.short", {
                                        ns: "common"
                                    })})`}
                                    dataIndex="maxOrder"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(errors, `options.merge.maxOrder`) &&
                                                getIn(touched, `options.merge.maxOrder`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(errors, `options.merge.maxOrder`) &&
                                                getIn(touched, `options.merge.maxOrder`)
                                                    ? getIn(errors, `options.merge.maxOrder`)
                                                    : null
                                            }
                                        >
                                            <Input
                                                type="number"
                                                name="maxOrder"
                                                data-testid="maxOrder"
                                                value={values.options.merge.maxOrder}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.maxOrder",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                    align="center"
                                />
                                <Column
                                    title={`${t(
                                        "fields.mergeOptions.mergeWithOtherVehicleTypes.label",
                                        {ns: "common"}
                                    )} (${t(
                                        "fields.mergeOptions.mergeWithOtherVehicleTypes.short",
                                        {
                                            ns: "common"
                                        }
                                    )})`}
                                    dataIndex="mergeWithOtherTypes"
                                    render={text => (
                                        <Form.Item>
                                            <Switch
                                                checked={values.options.merge.mergeWithOtherTypes}
                                                checkedChildren={t("other.active", {ns: "common"})}
                                                unCheckedChildren={t("other.passive", {
                                                    ns: "common"
                                                })}
                                                data-testid="mergeWithOtherTypes"
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.mergeWithOtherTypes",
                                                        e
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                    align="center"
                                />
                                <Column
                                    title={`${t(
                                        "fields.mergeOptions.mergeWithOtherCompanies.label2",
                                        {
                                            ns: "common"
                                        }
                                    )} (${t("fields.mergeOptions.mergeWithOtherCompanies.short", {
                                        ns: "common"
                                    })})`}
                                    dataIndex="mergeWithOtherCompanies"
                                    render={text => (
                                        <Form.Item>
                                            <Switch
                                                checked={
                                                    values.options.merge.mergeWithOtherCompanies
                                                }
                                                checkedChildren={t("other.active", {ns: "common"})}
                                                unCheckedChildren={t("other.passive", {
                                                    ns: "common"
                                                })}
                                                data-testid="mergeWithOtherCompanies"
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.mergeWithOtherCompanies",
                                                        e
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                    align="center"
                                />
                                <Column
                                    title={`${t("fields.mergeOptions.maxPickup.label", {
                                        ns: "common"
                                    })}(${t("units.piece.long", {
                                        ns: "common"
                                    })}) (${t("fields.mergeOptions.maxPickup.short", {
                                        ns: "common"
                                    })})`}
                                    dataIndex="maxPickup"
                                    render={text => (
                                        <Form.Item
                                            validateStatus={
                                                getIn(errors, `options.merge.maxPickup`) &&
                                                getIn(touched, `options.merge.maxPickup`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={
                                                getIn(errors, `options.merge.maxPickup`) &&
                                                getIn(touched, `options.merge.maxPickup`)
                                                    ? getIn(errors, `options.merge.maxPickup`)
                                                    : null
                                            }
                                        >
                                            <Input
                                                type="number"
                                                name="maxPickup"
                                                data-testid="maxPickup"
                                                value={values.options.merge.maxPickup}
                                                onChange={e => {
                                                    setFieldValue(
                                                        "options.merge.maxPickup",
                                                        e.target.value || ""
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                    align="center"
                                />
                            </FormikProvider>
                        </Table>
                    </CreateFormTableWrapper>
                    <LevelFormRow>
                        <Form.Item
                            validateStatus={
                                getIn(errors, `options.merge.level`) &&
                                getIn(touched, `options.merge.level`)
                                    ? "error"
                                    : "success"
                            }
                            help={
                                getIn(errors, `options.merge.level`) &&
                                getIn(touched, `options.merge.level`)
                                    ? getIn(errors, `options.merge.level`)
                                    : null
                            }
                            style={{marginRight: "16px", alignItems: "center"}}
                        >
                            <label style={{marginRight: "8px", fontWeight: "bold"}}>Seviye:</label>
                            <Input
                                style={{width: "100px", alignItems: "center"}}
                                placeholder="Seviye"
                                value={values.options.merge.level}
                                type="number"
                                onChange={e => setFieldValue("options.merge.level", e.target.value)}
                            />
                        </Form.Item>
                        <Form.Item
                            validateStatus={
                                getIn(errors, `options.merge.name`) &&
                                getIn(touched, `options.merge.name`)
                                    ? "error"
                                    : "success"
                            }
                            help={
                                getIn(errors, `options.merge.name`) &&
                                getIn(touched, `options.merge.name`)
                                    ? getIn(errors, `options.merge.name`)
                                    : null
                            }
                            style={{marginRight: "16px"}}
                        >
                            <label style={{marginRight: "8px", fontWeight: "bold"}}>
                                Seviye Adı:
                            </label>
                            <Input
                                style={{width: "200px"}}
                                placeholder="Seviye Adı"
                                value={values.options.merge.name}
                                onChange={e => setFieldValue("options.merge.name", e.target.value)}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button htmlType="submit" type="primary" data-testid="submitButton">
                                {t("actions.save", {ns: "common"})}
                            </Button>
                        </Form.Item>
                    </LevelFormRow>
                </Form>
            </TableContainer>

            <TableContainer>
                <DataTableWrapper>
                    <Table
                        dataSource={getFilteredData()}
                        loading={mergeOptionsLoading}
                        pagination={false}
                        rowKey="_id"
                        scroll={{x: "max-content"}}
                        onRow={record => {
                            const now = moment().tz("Europe/Istanbul");

                            // Eğer kaydın forceActiveUntil değeri varsa, şu anki zamandan sonra mı kontrol et
                            const isAfter =
                                record.forceActiveUntil &&
                                moment(record.forceActiveUntil)
                                    .tz("Europe/Istanbul")
                                    .valueOf() > now.valueOf();

                            // Tüm kayıtlar içinde gelecek tarihli zorunlu aktif var mı kontrol et
                            const hasAnyFutureForceActive = getFilteredData().some(
                                r =>
                                    r.forceActiveUntil &&
                                    moment(r.forceActiveUntil)
                                        .tz("Europe/Istanbul")
                                        .valueOf() > now.valueOf()
                            );

                            return {
                                style:
                                    // Sadece forceActiveUntil var ve gelecek tarihli ise yeşil göster
                                    isAfter
                                        ? {
                                              backgroundColor: "rgba(86, 234, 12, 0.33)"
                                          }
                                        : // Eğer hiç gelecek tarihli zorunlu aktif yoksa ve bu kayıt aktif ise yeşil göster
                                        !hasAnyFutureForceActive &&
                                          !record.forceActiveUntil &&
                                          record.isActive
                                        ? {
                                              backgroundColor: "rgba(86, 234, 12, 0.33)"
                                          }
                                        : {}
                            };
                        }}
                    >
                        <Column
                            title="Durum"
                            dataIndex="isActive"
                            align="center"
                            render={text =>
                                text ? <Tag color="green">Aktif</Tag> : <Tag color="red">Pasif</Tag>
                            }
                        />
                        <Column
                            title="Zorunlu Aktif"
                            dataIndex="forceActiveUntil"
                            align="center"
                            render={text => {
                                if (text) {
                                    const endTime = moment(text).tz("Europe/Istanbul");
                                    const now = moment().tz("Europe/Istanbul");
                                    const isAfter = endTime.isAfter(now);
                                    return isAfter ? (
                                        <Tag color="green">Aktif</Tag>
                                    ) : (
                                        <Tag color="red">Pasif</Tag>
                                    );
                                }
                                return <Tag color="red">Pasif</Tag>;
                            }}
                        />
                        <Column
                            title="İşlem"
                            dataIndex="isActive"
                            align="center"
                            render={(text, record) => (
                                <Row justify="center" align="middle" gutter={8}>
                                    <Popconfirm
                                        title="Silmek istediğinize emin misiniz?"
                                        onConfirm={() => onDelete(record._id)}
                                        okText="Evet"
                                        cancelText="Hayır"
                                    >
                                        <Button
                                            danger
                                            size="small"
                                            type="primary"
                                            style={{marginRight: "8px"}}
                                        >
                                            Sil
                                        </Button>
                                    </Popconfirm>
                                    <Button
                                        size="small"
                                        style={{
                                            marginRight: "8px",
                                            color: "white",
                                            backgroundColor: "#ffb300",
                                            borderColor: "#ffb300"
                                        }}
                                        type="primary"
                                        onClick={() => onEdit(record)}
                                    >
                                        Düzenle
                                    </Button>
                                    {record.forceActiveUntil &&
                                    moment(record.forceActiveUntil)
                                        .tz("Europe/Istanbul")
                                        .isAfter(moment().tz("Europe/Istanbul")) ? (
                                        <>
                                            <Popconfirm
                                                title="İptal etmek istediğinize emin misiniz?"
                                                onConfirm={() =>
                                                    onStatusChange({
                                                        mergeOptionId: record._id,
                                                        isActive: false
                                                    })
                                                }
                                                okText="Evet"
                                                cancelText="Hayır"
                                            >
                                                <Button danger size="small" type="default">
                                                    İptal Et
                                                </Button>
                                            </Popconfirm>
                                        </>
                                    ) : (
                                        <Button
                                            size="small"
                                            type="primary"
                                            ghost
                                            onClick={() => showModal(record)}
                                        >
                                            Zorunlu Aktif Et
                                        </Button>
                                    )}
                                </Row>
                            )}
                        />

                        <Column
                            title="Sonlanacağı Zaman"
                            dataIndex="forceActiveUntil"
                            align="center"
                            width={100}
                            render={text => {
                                if (text) {
                                    const endTime = moment(text).tz("Europe/Istanbul");
                                    const now = moment().tz("Europe/Istanbul");
                                    const isAfter = endTime.isAfter(now);
                                    return isAfter ? endTime.format("DD.MM.YYYY HH:mm") : "-";
                                }
                                return "-";
                            }}
                        />
                        <Column title="Seviye" dataIndex="level" align="center" width={50} />
                        <Column title="Seviye Adı" dataIndex="name" align="center" width={75} />
                        <Column
                            title="Havuz Oranı (HO)"
                            dataIndex="poolRate"
                            align="center"
                            width={100}
                            render={text => {
                                if (text === -1) {
                                    return <Tag color="red">Devre Dışı</Tag>;
                                }
                                return text;
                            }}
                        />
                        <Column
                            title="Kuyruktaki Sipariş Sayısı (KSS)"
                            dataIndex="orderOnQueue"
                            align="center"
                            width={100}
                            render={text => {
                                if (text === -1) {
                                    return <Tag color="red">Devre Dışı</Tag>;
                                }
                                return text;
                            }}
                        />
                        <Column
                            title="Kapasite Oranı (KO)"
                            dataIndex="capacityRate"
                            align="center"
                            width={100}
                            render={text => {
                                if (text === -1) {
                                    return <Tag color="red">Devre Dışı</Tag>;
                                }
                                return text;
                            }}
                        />
                        <Column
                            title={`${t("fields.mergeOptions.clickToDoorTime.label", {
                                ns: "common"
                            })}(${t("units.minute.short", {
                                ns: "common"
                            })}) (${t("fields.mergeOptions.clickToDoorTime.short", {
                                ns: "common"
                            })})`}
                            dataIndex="clickToDoorTime"
                            align="center"
                            width={100}
                        />
                        <Column
                            title={`${t("fields.mergeOptions.prepTime.label", {
                                ns: "common"
                            })}(${t("units.minute.short", {
                                ns: "common"
                            })}) (${t("fields.mergeOptions.prepTime.short", {ns: "common"})})`}
                            dataIndex="prepTime"
                            align="center"
                            width={100}
                        />
                        <Column
                            title={`${t("fields.mergeOptions.prepTimeBufferPercent.label", {
                                ns: "common"
                            })}(%) (${t("fields.mergeOptions.prepTimeBufferPercent.short", {
                                ns: "common"
                            })})`}
                            dataIndex="prepTimeBufferPercent"
                            align="center"
                            width={100}
                        />
                        <Column
                            title={`${t("fields.mergeOptions.handOverTime.label", {
                                ns: "common"
                            })}(${t("units.minute.short", {
                                ns: "common"
                            })}) (${t("fields.mergeOptions.handOverTime.short", {ns: "common"})})`}
                            dataIndex="handOverTime"
                            align="center"
                            width={100}
                        />
                        <Column
                            title={`${t("fields.mergeOptions.mergeMaxOrder.label", {
                                ns: "common"
                            })}(${t("units.piece.long", {
                                ns: "common"
                            })}) (${t("fields.mergeOptions.mergeMaxOrder.short", {ns: "common"})})`}
                            dataIndex="maxOrder"
                            align="center"
                            width={100}
                        />
                        <Column
                            title={`${t("fields.mergeOptions.mergeWithOtherVehicleTypes.label", {
                                ns: "common"
                            })} (${t("fields.mergeOptions.mergeWithOtherVehicleTypes.short", {
                                ns: "common"
                            })})`}
                            dataIndex="mergeWithOtherTypes"
                            align="center"
                            render={text =>
                                text ? <Tag color="green">Aktif</Tag> : <Tag color="red">Pasif</Tag>
                            }
                            width={100}
                        />
                        <Column
                            title={`${t("fields.mergeOptions.mergeWithOtherCompanies.label2", {
                                ns: "common"
                            })} (${t("fields.mergeOptions.mergeWithOtherCompanies.short", {
                                ns: "common"
                            })})`}
                            dataIndex="mergeWithOtherCompanies"
                            align="center"
                            render={text =>
                                text ? <Tag color="green">Aktif</Tag> : <Tag color="red">Pasif</Tag>
                            }
                            width={100}
                        />
                        <Column
                            title={`${t("fields.mergeOptions.maxPickup.label", {
                                ns: "common"
                            })} (${t("fields.mergeOptions.maxPickup.short", {ns: "common"})})`}
                            dataIndex="maxPickup"
                            align="center"
                            width={100}
                        />
                    </Table>
                </DataTableWrapper>
            </TableContainer>

            <TableContainer>
                <FilterSection>
                    <Select onChange={onChangeFilter} value={filterValue} style={{width: "230px"}}>
                        {filterOptions.map(item => (
                            <Select.Option key={item.key} value={item.key}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Popconfirm
                        title="Tüm alt firmaları aktif ayar ile güncellemek istediğinize emin misiniz?"
                        onConfirm={() => onUpdateAllSubCompanies()}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button type="primary">Tüm Alt Firmaları Aktif Ayarlar İle Güncelle</Button>
                    </Popconfirm>
                </FilterSection>
                <Table
                    dataSource={poolSubCompanies.companies}
                    loading={poolSubCompaniesLoading}
                    pagination={true}
                    rowKey="_id"
                >
                    <Column
                        title="Firma Adı"
                        dataIndex="companyName"
                        align="center"
                        render={(text, record) => (
                            <Link
                                target="_blank"
                                to={`/companies/merge-options/${record.companyId}`}
                            >
                                {text}
                            </Link>
                        )}
                    />
                    <Column
                        title="Havuz Birleştirme Ayarı Kullanan Alt Firma Sayısı"
                        dataIndex="usingCount"
                        align="center"
                    />
                    <Column
                        title="Havuz Birleştirme Ayarı Kullanmayan Alt Firma Sayısı"
                        dataIndex="notUsingCount"
                        align="center"
                    />
                </Table>
            </TableContainer>

            <Modal title="Aktif Et" visible={isModalVisible} onCancel={handleCancel} footer={null}>
                <p>Kaç dakika boyunca aktif edilsin?</p>
                <Input
                    type="number"
                    value={timeValue}
                    onChange={e => setTimeValue(e.target.value)}
                    style={{marginTop: "16px"}}
                />
                <div style={{marginTop: "16px", textAlign: "right"}}>
                    <Button onClick={handleCancel} style={{marginRight: 8}}>
                        İptal
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => {
                            if (selectedRecord) {
                                onStatusChange({
                                    mergeOptionId: selectedRecord._id,
                                    isActive: true,
                                    timeMinutes: timeValue
                                });
                            }
                            setIsModalVisible(false);
                            setSelectedRecord(null);
                        }}
                    >
                        Onayla
                    </Button>
                </div>
            </Modal>

            <Modal
                title="Düzenle"
                visible={isEditModalVisible}
                onCancel={handleEditCancel}
                footer={null}
                width="90%"
                style={{maxWidth: 1200}}
            >
                <Form
                    form={editForm}
                    onFinish={handleEditSubmit}
                    layout="vertical"
                    autoComplete="off"
                >
                    <EditModalLevelRow>
                        <span style={{fontWeight: "bold", marginRight: "8px"}}>Seviye:</span>
                        <Form.Item
                            name="level"
                            style={{display: "inline-block", marginBottom: 0, marginRight: "16px"}}
                            rules={[{required: true, message: "Lütfen seviye giriniz"}]}
                        >
                            <Input style={{width: "100px"}} type="number" placeholder="Seviye" />
                        </Form.Item>

                        <span style={{fontWeight: "bold", marginRight: "8px"}}>Seviye Adı:</span>
                        <Form.Item
                            name="name"
                            style={{display: "inline-block", marginBottom: 0}}
                            rules={[{required: true, message: "Lütfen seviye adı giriniz"}]}
                        >
                            <Input style={{width: "200px"}} placeholder="Seviye Adı" />
                        </Form.Item>
                    </EditModalLevelRow>

                    <EditModalTableWrapper>
                        <Table
                            dataSource={[{}]}
                            rowKey="_id"
                            pagination={false}
                            style={{padding: 0}}
                            scroll={{x: "max-content"}}
                        >
                            <Column
                                title="Havuz Oranı (HO)"
                                dataIndex="poolRate"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="poolRate"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen havuz oranını giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                            <Column
                                title="Kuyruktaki Sipariş Sayısı (KSS)"
                                dataIndex="orderOnQueue"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="orderOnQueue"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen kuyruk sipariş sayısını giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                            <Column
                                title="Kapasite Oranı (KO)"
                                dataIndex="capacityRate"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="capacityRate"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen kapasite oranını giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                            <Column
                                title={`${t("fields.mergeOptions.clickToDoorTime.label", {
                                    ns: "common"
                                })}(${t("units.minute.short", {
                                    ns: "common"
                                })}) (${t("fields.mergeOptions.clickToDoorTime.short", {
                                    ns: "common"
                                })})`}
                                dataIndex="clickToDoorTime"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="clickToDoorTime"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen click to door time'ı giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                            <Column
                                title={`${t("fields.mergeOptions.prepTime.label", {
                                    ns: "common"
                                })}(${t("units.minute.short", {
                                    ns: "common"
                                })}) (${t("fields.mergeOptions.prepTime.short", {ns: "common"})})`}
                                dataIndex="prepTime"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="prepTime"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen prep time'ı giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                            <Column
                                title={`${t("fields.mergeOptions.prepTimeBufferPercent.label", {
                                    ns: "common"
                                })}(%) (${t("fields.mergeOptions.prepTimeBufferPercent.short", {
                                    ns: "common"
                                })})`}
                                dataIndex="prepTimeBufferPercent"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="prepTimeBufferPercent"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen prep time buffer percent'ı giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                            <Column
                                title={`${t("fields.mergeOptions.handOverTime.label", {
                                    ns: "common"
                                })}(${t("units.minute.short", {
                                    ns: "common"
                                })}) (${t("fields.mergeOptions.handOverTime.short", {
                                    ns: "common"
                                })})`}
                                dataIndex="handOverTime"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="handOverTime"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen hand over time'ı giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                            <Column
                                title={`${t("fields.mergeOptions.mergeMaxOrder.label", {
                                    ns: "common"
                                })}(${t("units.piece.long", {
                                    ns: "common"
                                })}) (${t("fields.mergeOptions.mergeMaxOrder.short", {
                                    ns: "common"
                                })})`}
                                dataIndex="maxOrder"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="maxOrder"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen merge max order'ı giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                            <Column
                                title={`${t(
                                    "fields.mergeOptions.mergeWithOtherVehicleTypes.label",
                                    {
                                        ns: "common"
                                    }
                                )} (${t("fields.mergeOptions.mergeWithOtherVehicleTypes.short", {
                                    ns: "common"
                                })})`}
                                dataIndex="mergeWithOtherTypes"
                                align="center"
                                render={() => (
                                    <Form.Item name="mergeWithOtherTypes" valuePropName="checked">
                                        <Switch
                                            checkedChildren={t("other.active", {ns: "common"})}
                                            unCheckedChildren={t("other.passive", {ns: "common"})}
                                        />
                                    </Form.Item>
                                )}
                                width={100}
                            />
                            <Column
                                title={`${t("fields.mergeOptions.mergeWithOtherCompanies.label2", {
                                    ns: "common"
                                })} (${t("fields.mergeOptions.mergeWithOtherCompanies.short", {
                                    ns: "common"
                                })})`}
                                dataIndex="mergeWithOtherCompanies"
                                align="center"
                                render={() => (
                                    <Form.Item
                                        name="mergeWithOtherCompanies"
                                        valuePropName="checked"
                                    >
                                        <Switch
                                            checkedChildren={t("other.active", {ns: "common"})}
                                            unCheckedChildren={t("other.passive", {ns: "common"})}
                                        />
                                    </Form.Item>
                                )}
                                width={100}
                            />
                            <Column
                                title={`${t("fields.mergeOptions.maxPickup.label", {
                                    ns: "common"
                                })} (${t("fields.mergeOptions.maxPickup.short", {ns: "common"})})`}
                                dataIndex="maxPickup"
                                align="center"
                                width={100}
                                render={() => (
                                    <Form.Item
                                        name="maxPickup"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Lütfen max pickup'ı giriniz"
                                            }
                                        ]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>
                                )}
                            />
                        </Table>
                    </EditModalTableWrapper>

                    <EditModalActions>
                        <Button onClick={handleEditCancel}>İptal</Button>
                        <Button type="primary" htmlType="submit">
                            Kaydet
                        </Button>
                    </EditModalActions>
                </Form>
            </Modal>
        </PageWrapper>
    );
};

export default PoolMergeOptions;
